import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";
import {CommonsModule} from "../../commons/angular/commons.module";
import {siteProvidersDialogsServiceProvider} from "../../../providers";
import {SiteProvidersViewComponent} from "./components/site-providers-view/site-providers-view.component";
import {SiteProvidersTableComponent} from "./components/site-providers-table/site-providers-table.component";
import {
  SiteProvidersTableRowComponent
} from "./components/site-providers-table-row/site-providers-table-row.component";
import {
  SiteProviderActionMenuComponent
} from "./components/site-provider-action-menu/site-provider-action-menu.component";
import {SettingsAuditLogComponent} from "./components/settings-audit-log/settings-audit-log.component";
import {SettingsAuditLogDetailComponent} from "./components/settings-audit-log/settings-audit-log-detail.component";

/**
 * Imported by AppModule rather than bootstrapped on its own: these components are downgraded
 * into the AngularJS router through downgradedAppModule, so they have to share that injector -
 * that is the one TranslationsService fills with the i18n dictionary.
 */
@NgModule({
  declarations: [
    SiteProvidersViewComponent,
    SiteProvidersTableComponent,
    SiteProvidersTableRowComponent,
    SiteProviderActionMenuComponent,
    SettingsAuditLogComponent,
    SettingsAuditLogDetailComponent
  ],
  imports: [
    CommonModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild()
  ],
  providers: [
    siteProvidersDialogsServiceProvider
  ],
  exports: [
    SiteProvidersViewComponent,
    SettingsAuditLogComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SitePreferencesAngularModule {
  constructor() {
  }
}
